import { Card } from "react-bootstrap";
import { useDispatch } from "react-redux";
import { useTranslation } from "react-i18next";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import { ChangeIsUpdateOperation, ShowUpsertPositionModal, UpdateUpsertPositionModalData } from "../Store";
import { useNavigate } from "react-router-dom";
import IconSvg from "../../../SharedComponents/IconSvg";
import Button from "react-bootstrap/Button";

const PositionList = ({ positionList }) => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const HandleUpdateClick = (position) => {
    dispatch(UpdateUpsertPositionModalData(position));
    dispatch(ChangeIsUpdateOperation({ isUpdateOperation: true }));
    dispatch(ShowUpsertPositionModal({ upsertPositionModalIsShown: true }));
  };

  return (
    <Row className="mx-0">
      {positionList &&
        positionList.map((position, i) => (
          <Col xs={12} md={6} xl={4} xxl={3} xxxl={2} key={i} className="mb-4">
            <Card className="default-card">
              <div className="d-flex flex-column p-3 " style={{ minHeight: "330px" }}>
                <Row>
                  <Col className="text-16 text-color-gray-light fw-medium">ID {position.id}</Col>
                  <Col xs="auto">
                    <div
                      className="hover-bg-darken p-1"
                      onClick={() => {
                        HandleUpdateClick(position);
                      }}
                    >
                      <IconSvg icon="edit" />
                    </div>
                  </Col>
                </Row>

                <Row className="justify-content-center mt-3">
                  <Col xs="auto">
                    <IconSvg icon="shopping-bag" width={52} height={52} />
                  </Col>
                </Row>

                <Row>
                  <Col className="text-center text-24 text-color-gray-dark fw-medium mt-4">{position.name}</Col>
                </Row>

                <Row className="mt-2">
                  <Col className="text-center text-12 text-color-gray-light">
                    {position.jobLevelName && <span>{position.jobLevelName}</span>}
                    {position.jobLevelName && position.jobGroupName && <span> • </span>}
                    {position.jobGroupName && <span>{position.jobGroupName}</span>}
                    {(position.jobLevelName || position.jobGroupName) && position.departmentName && <span> • </span>}
                    {position.departmentName && <span>{position.departmentName}</span>}
                  </Col>
                </Row>

                <Row className="mt-auto mb-4 justify-content-center">
                  <Col xs="auto">
                    <Button
                      onClick={() => {
                        navigate("/position", { state: { positionId: position.id } });
                      }}
                      className="button secondary text-20"
                    >
                      {t("goToPositionButtonLabel")}
                    </Button>
                  </Col>
                </Row>
              </div>
            </Card>
          </Col>
        ))}
    </Row>
  );
};

export default PositionList;
